<template>
  <div :class="{ 'spacing-mb-15': !isMobile }">
    <div class="is-mobile wrapper-advanced-search">
      <section class="search-box column is-8" :class="{ 'is-full': isMobile }">
        <b-autocomplete
          class="search-input"
          :class="{ 'spacing-mx-20': !isMobile }"
          role="searchbox"
          expanded
          :value="searchValue"
          :data="getFields"
          size="is-large"
          rounded
          field="name"
          name="search"
          :placeholder="General.PLACEHOLDER.SEARCH_BY_NUP_NAME_SUBJECT"
          icon="magnify"
          :iconRight="showIconRight"
          :iconRightClickable="isSearchSuite"
          keepFirst
          @typing="setSearchField"
          @select="option => onSelectSuggestion(option)"
          @icon-right-click="showFilterModal()"
        />
        <div
          v-if="isExternalSearch"
          class="is-flex mt-10 pl-40 is-justify-content-space-between"
        >
          <div class="radius">
            <b-radio
              v-for="(option, index) in Object.values(searchOptions)"
              :key="index"
              v-model="isSearchSuite"
              :type="isContrast ? 'is-white' : 'is-green-lawn'"
              :nativeValue="option.value"
            >
              {{ option.name }}
              <b-tooltip
                :label="option.description"
                :type="isContrast ? 'is-white' : 'is-blue-oil'"
              >
                {{ option.example }}
              </b-tooltip>
            </b-radio>
          </div>
        </div>
        <div
          v-if="isSearchSuite"
          class="is-flex is-justify-content-flex-end mt-10 mr-35"
        >
          <ConsultProcessFilterTagList />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import debounce from "lodash/debounce";

import { General } from "@/utils/constants";
import { getFormattedFilterList } from "@/utils/filterTagsUtility";
import ModalFilterConsultProcess from "@/views/App/ModalFilterConsultProcess";
import ConsultProcessFilterTagList from "@/components/ConsultProcessFilterTagList";
import { EXTERNAL_SEARCH_OPTIONS as searchOptions } from "@/utils/enumerate";

export default {
  name: "CustomAdvancedSearch",
  components: {
    ConsultProcessFilterTagList
  },

  props: {
    isExternalSearch: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      General,
      searchOptions,
      searchValue: "",
      filterTags: [],
      currentFilterList: [],
      filterList: {},
      removedFilterId: {}
    };
  },

  computed: {
    ...mapGetters({
      getSuggests: "getSuggests",
      filters: "getFilterList",
      getIsSearchSuite: "getIsSearchSuite",
      isMobile: "isMobile",
      isContrast: "isContrast"
    }),

    isSearchSuite: {
      get() {
        return this.getIsSearchSuite;
      },
      set(value) {
        this.setSearchSuite(value);
      }
    },

    getFields() {
      const list = this.getSuggests.map(suggest => ({
        name: suggest.toLowerCase()
      }));
      return this.searchValue.length
        ? [{ name: this.searchValue }, ...list]
        : list;
    },

    showIconRight() {
      if (this.isSearchSuite) return "tune custom-right";
      else return "";
    }
  },

  watch: {
    filterTags: {
      handler() {
        this.getFilterListRequest();
        if (
          this.$router.currentRoute.name !== "processConsult" &&
          this.$router.currentRoute.name !== "Busca"
        )
          this.$router.push("/app/busca");
      },
      deep: true
    },
    filters(newValueFilter) {
      this.setFiltersParams(newValueFilter);
    }
  },

  beforeMount() {
    this.setFiltersParams(this.filters);
  },

  methods: {
    ...mapActions({
      getFieldsForSearch: "getFieldsForSearch"
    }),

    ...mapMutations({
      setSuggests: "setSuggests",
      setFilterList: "setFilterList",
      setSearchSuite: "setSearchSuite"
    }),

    getFilterListRequest() {
      this.setFilterList({
        search: this.searchValue,
        currentFilterList: this.currentFilterList
      });
    },

    onSelectSuggestion(option) {
      if (option) {
        this.searchValue = option.name;
        this.getFilterListRequest();
        if (
          ![
            "processConsult",
            "processConsultDetail",
            "viprocConsult",
            "Busca"
          ].includes(this.$router.currentRoute.name)
        )
          this.$router.push("/app/busca");
      }
    },

    setSearchField(value) {
      this.searchValue = value || "";
      this.requestFields(value);
    },

    requestFields: debounce(async function(value) {
      const searchTexts = value.trim().split(" ");
      searchTexts[0] !== "" &&
        (await this.getFieldsForSearch({
          filter: searchTexts[searchTexts.length - 1]
        }));
    }, 600),

    removeFilterTag(index) {
      this.filterTags.splice(index, 1);
    },

    showFilterModal() {
      if (this.isSearchSuite)
        this.$buefy.modal.open({
          parent: this,
          component: ModalFilterConsultProcess,
          props: {
            onApply: value => {
              this.currentFilterList = [...value];
              this.filterList = getFormattedFilterList(this.currentFilterList);
              this.getFilterListRequest();
            }
          },
          hasModalCard: true,
          trapFocus: true
        });
    },

    setFiltersParams({ search, currentFilterList }) {
      if (
        this.searchValue !== search ||
        this.currentFilterList !== currentFilterList
      ) {
        this.searchValue = search || "";
        this.currentFilterList = currentFilterList;
        this.filterList = getFormattedFilterList(this.currentFilterList);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper-advanced-search {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  flex-wrap: wrap;
}
</style>

<style lang="scss">
@import "@/assets/scss/variables";
.custom-right {
  color: $color-7;
  margin-right: 10px;
}
</style>
